module.exports = __webpack_public_path__ + "static/media/menu.6e5074a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/menu.svg
// module id = ./src/assets/media/forum/menu.svg
// module chunks = 16